import * as React from 'react';
import {Route, RouteComponentProps, Switch, withRouter} from 'react-router';
import UserList from './UserList';
import UserEdit from './UserEdit';
import NewUser from './NewUser';

interface UserListProps extends RouteComponentProps<{}> {
}

interface UserListState {
}

class UserManagementRoute extends React.Component<UserListProps, UserListState> {
  public render() {
    const match = this.props.match;
    return (
        <Switch>
          <Route path={`${match.path}/new`} component={NewUser} />
          <Route path={`${match.path}/:userId`} component={UserEdit} />
          <Route component={UserList}/>
        </Switch>
    );
  }
}

export default withRouter(UserManagementRoute);